var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10127IconServiceVirtualClusters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a876d441-6985-4b03-ac91-0cfb754233ca",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac8ec029-dede-4106-852c-6daca45a4fea",
    x1: 5.35,
    y1: 7.02,
    x2: 5.35,
    y2: 17.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b2b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#afaeaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#a2a2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#979797"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b524cf9e-cab2-4314-a18d-cd0ba7515d77",
    x1: 11.33,
    y1: 15.74,
    x2: 11.33,
    y2: 6.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0078d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1380da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#3c91e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#559cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5ea0ef"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-databases-127") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.77,10.68a.39.39,0,0,1-.42.34H.92a.39.39,0,0,1-.42-.34V1.2A.39.39,0,0,1,.92.86H7.35a.39.39,0,0,1,.42.34Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57,5.2a.79.79,0,0,1,.79-.79H6a.79.79,0,0,1,.79.79h0A.79.79,0,0,1,6,6H2.36a.79.79,0,0,1-.79-.79Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57,2.86a.79.79,0,0,1,.79-.8H6a.79.79,0,0,1,.79.8h0A.79.79,0,0,1,6,3.65H2.36a.79.79,0,0,1-.79-.79Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.39,
    cy: 2.86,
    r: 0.53,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.39,
    cy: 5.2,
    r: 0.53,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.79,10.63a.39.39,0,0,1-.42.35H8.94a.39.39,0,0,1-.42-.35V1.16A.39.39,0,0,1,8.94.81h6.43a.39.39,0,0,1,.42.35Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59,5.16a.79.79,0,0,1,.79-.79H14a.79.79,0,0,1,.79.79h0A.79.79,0,0,1,14,6H10.38a.79.79,0,0,1-.79-.79Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59,2.81A.79.79,0,0,1,10.38,2H14a.8.8,0,0,1,.79.79h0A.79.79,0,0,1,14,3.6H10.38a.79.79,0,0,1-.79-.79Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.41,
    cy: 2.81,
    r: 0.53,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.41,
    cy: 5.16,
    r: 0.53,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,16.84a.39.39,0,0,1-.42.35H2.14a.39.39,0,0,1-.42-.35V7.37A.39.39,0,0,1,2.14,7H8.57A.39.39,0,0,1,9,7.37Z",
    fill: "url(#ac8ec029-dede-4106-852c-6daca45a4fea)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79,11.37a.79.79,0,0,1,.79-.79H7.2a.79.79,0,0,1,.79.79H8a.8.8,0,0,1-.79.79H3.58a.79.79,0,0,1-.79-.79Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79,9a.79.79,0,0,1,.79-.79H7.2A.79.79,0,0,1,8,9H8a.8.8,0,0,1-.79.79H3.58A.79.79,0,0,1,2.79,9Z",
    fill: "#003067"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.61,
    cy: 9.02,
    r: 0.53,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.61,
    cy: 11.37,
    r: 0.53,
    fill: "#50e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,13a2.77,2.77,0,0,0-2.41-2.66A3.49,3.49,0,0,0,11.5,7,3.58,3.58,0,0,0,8.07,9.33a3.31,3.31,0,0,0-2.91,3.18,3.37,3.37,0,0,0,3.48,3.23h5.93a.4.4,0,0,0,.15,0A2.8,2.8,0,0,0,17.5,13Z",
    fill: "url(#b524cf9e-cab2-4314-a18d-cd0ba7515d77)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10127IconServiceVirtualClusters);
export default __webpack_public_path__ + "static/media/10127-icon-service-Virtual-Clusters.e28cfd6e282ba49466ffce7698a903a7.svg";
export { ForwardRef as ReactComponent };